import React from 'react'

const VisionMission = () => {
    return (
        <>
            <div className="vision-mission">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-6">
                            {/* Section Title Start */}
                            <div className="section-title dark-section">
                                <h3
                                    className="wow fadeInUp"
                                    style={{ fontSize: 25, color: "#7c877f" }}
                                >
                                    vision mission
                                </h3>
                                <h2 className="text-anime-style-2" data-cursor="-opaque">
                                    A behind the scenes look at <span>our agency</span>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                        <div className="col-lg-6">
                            {/* Section Title Content Start */}
                            <div className="section-title-content dark-section">
                                <p className="wow fadeInUp" data-wow-delay="0.2s">
                                    Our portfolio showcases a diverse range of projects, from
                                    beautifully crafted residential spaces functional and stylish
                                    commercial interiors
                                </p>
                            </div>
                            {/* Section Title Content End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Vision Mission Box Start */}
                            <div className="vision-mission-box">
                                {/* Vision Mission Item Start */}
                                <div className="vision-mission-item wow fadeInUp">
                                    <div className="icon-box">
                                        <img src="images/icon-our-vision.svg" alt="" />
                                    </div>
                                    <div className="vision-mission-content">
                                        <h3>our vision</h3>
                                        <p>
                                            Our vision is rooted in the belief that thoughtfully designed
                                            spaces can transform lives, enhancing how people feel, work, and
                                            connect. We are committed to creating interiors that reflect our
                                            clients' unique identities, blending comfort, functionality, and
                                            beauty. By combining timeless design with modern innovations, we
                                            craft spaces that are visually stunning and practical.
                                        </p>
                                    </div>
                                </div>
                                {/* Vision Mission Item End */}
                                {/* Vision Mission Item Start */}
                                <div
                                    className="vision-mission-item wow fadeInUp"
                                    data-wow-delay="0.2s"
                                >
                                    <div className="icon-box">
                                        <img src="images/icon-our-mission.svg" alt="" />
                                    </div>
                                    <div className="vision-mission-content">
                                        <h3>our mission</h3>
                                        <p>
                                            Our mission is to deliver exceptional interior designs that
                                            enhance the quality of life by prioritizing comfort,
                                            functionality, and aesthetics. We aim to create space that are
                                            not only visually appealing but also tailored to meet the
                                            specific needs and desires of our client By staying true to
                                            design innovation, we ensure that every project reflects the
                                            perfect balance between style and purpose.
                                        </p>
                                    </div>
                                </div>
                                {/* Vision Mission Item End */}
                            </div>
                            {/* Vision Mission Box End */}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default VisionMission
